<template>
  <div class="side-card-container">
    <div class="card-side-graph">
      <div class="card-icon ban-color">
        <i class="fas fa-ban"></i>
      </div>
      <div class="card-section-body">
        <div class="header">Ads Blocked</div>
        <h3 class="ads-blocked-section">{{transformUnit(adsBlocked)}}</h3>
      </div>
    </div>
    <div class="card-side-graph">
      <div class="card-icon play-color">
        <i class="fas fa-play"></i>
      </div>
      <div class="card-section-body">
        <div class="header">Total Play</div>
        <h3 class="total-play-section">{{transformUnit(totalPlay)}}</h3>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import numberUtils from '@/utils/numberUtils';

export default {
  mixins: [numberUtils],
  props: ['data', 'isLoading'],
  computed: {
    totalPlay() {
      return _.get(this.data, 'total_play', 0);
    },
    adsBlocked() {
      return _.get(this.data, 'ad_block', 0);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.side-card-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.card-side-graph {
  padding: $spacer;
  margin: $spacer $spacer;
  flex: 1;
  justify-content: center;
  max-height: 200px;
  text-align: center;
  display: flex;
  flex-direction: row;

  .card-icon {
    justify-content: flex-start;
    align-self: center;
    border-radius: 5px;
    padding: $spacer;
  }

  .card-section-body {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-left: $spacer;
  }

  .ban-color {
    background: #eb5757;
  }

  .play-color {
    background: #828282;
  }

  i {
    color: $white;
    font-size: $font-size-lg * 1.75;
  }

  .header {
    color: $gray-600;
    font-size: $font-size-base * 1.15;
    font-weight: 300;
    text-align: left;
    text-transform: uppercase;
  }

  h3 {
    color: $gray-800;
    font-size: $font-size-lg * 2;
    margin: 0;
  }

  .total-play-section {
    color: #828282;
  }

  .ads-blocked-section {
    color: #eb5757;
  }

  &:first-child {
    // text-align: left;
    // margin-left: 0;
    // padding-left: 0;
  }

  &:last-child {
    // margin-right: 0;
    // padding-right: 0;
    // text-align: right;
  }
}

@media (min-width: 320px) and (max-width: 767.98px) {
  .card-side-graph {
    padding: $spacer / 2;
    margin: $spacer / 2 0;
    flex: 1;
    flex-wrap: wrap;
    flex-direction: row;
    .header {
      font-size: $font-size-base;
      font-weight: 300;
      text-align: left;
    }

    .card-section-body {
      margin-left: $spacer / 4;
    }

    h3 {
      color: $gray-800;
      font-size: $font-size-lg;
      margin: 0;
    }

    i {
      color: $white;
      font-size: $font-size-lg * 0.875;
    }

    .card-icon {
      padding: $spacer / 2;
    }
  }
}

@media (min-width: 768px) and (max-width: 1199.98px) {
  .card-side-graph {
    padding: $spacer / 2;
    margin: $spacer 0;
    flex: 1;
    flex-wrap: wrap;
    flex-direction: row;
    .header {
      font-size: $font-size-base;
      font-weight: 300;
      text-align: left;
    }

    .card-section-body {
      margin-left: $spacer / 4;
    }

    h3 {
      color: $gray-800;
      font-size: $font-size-lg;
      margin: 0;
    }

    i {
      color: $white;
      font-size: $font-size-lg * 0.875;
    }

    .card-icon {
      padding: $spacer / 2;
    }
  }
}
</style>
